import { Base } from '@studiometa/js-toolkit';
import { clamp, damp, transform } from '@studiometa/js-toolkit/utils';

/**
 * Navbar
 */
export default class Navbar extends Base {
  static config = {
    name: 'Navbar',
    emits: ['done'],
  };

  y = 0;

  dampedY = 0;

  dampFactor = 0.7;

  dampFactorAuto = 0.7;

  dampFactorMethod = 0.1;

  lastDirection = null;

  /**
   * targetY
   * @returns {number}
   */
  get targetY() {
    return this.$el.offsetHeight * -1;
  }

  /**
   * Scrolled
   * @param {object} props
   * @param {number} props.y
   * @param {object} props.direction
   * @param {object} props.delta
   * @param {object} props.progress
   * @param {object} props.max
   * @returns {void}
   */
  scrolled({ y, direction, delta, progress, max }) {
    // @TODO: disable for the singles
    if (direction.y === 'NONE') {
      if (y < 96) {
        return;
      }
      if (this.lastDirection === 'UP' || progress.y >= 1) {
        this.show();
        return;
      }
      this.hide();
      return;
    }

    if (max.y <= 0) {
      return;
    }

    this.lastDirection = direction.y;

    if (progress.y < 0) {
      this.y = 0;
      return;
    }

    if (progress.y >= 1) {
      this.y = this.targetY;
      return;
    }

    this.dampFactor = this.dampFactorAuto;
    this.y = clamp(this.y - delta.y, 0, this.targetY);
    this.$services.enable('raf');
  }

  /**
   * Ticked
   */
  ticked() {
    this.dampedY = damp(this.y, this.dampedY, this.dampFactor);
    transform(this.$el, {
      y: this.dampedY,
    });
    const logo = this.$el.querySelector('[data-logo]');
    if (logo) {
      transform(logo, {
        y: -this.dampedY,
      });
    }
    if (this.dampedY === this.y) {
      this.$emit('done', this.dampedY);
      this.$services.disable('raf');
    }
  }

  /**
   * Show
   * @returns {Promise}
   */
  show() {
    this.dampFactor = this.dampFactorMethod;
    this.y = 0;
    this.$services.enable('raf');
    return new Promise((resolve) => {
      this.$on('done', resolve, { once: true });
    });
  }

  /**
   * Hide
   * @returns {Promise}
   */
  hide() {
    this.dampFactor = this.dampFactorMethod;
    this.y = this.targetY;
    this.$services.enable('raf');
    return new Promise((resolve) => {
      this.$on('done', resolve, { once: true });
    });
  }

  /**
   * onMouseenter
   */
  onMouseenter() {
    this.show();
  }
}
